import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalComponent } from "../modal/modal.component";
import { CommonService } from "src/app/common.service";
import {
  PaymentInfo,
  PaymentMethod,
  PaymentIntent as ProfilePaymentIntent,
  Profile,
} from "profile-api";
import { ConfigurationVariablesList } from "std-api";
import { GetCreditCardName } from "../utils/credit-card-name-getter";
import { Participation } from "participation-api";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { StripeService } from "ngx-stripe";
import { PaymentIntent } from "@stripe/stripe-js";
import * as moment from "moment";

@Component({
  selector: "app-buy-tender-participation",
  templateUrl: "./buy-tender-participation.component.html",
  styleUrls: ["./buy-tender-participation.component.css"],
})
export class BuyTenderParticipationComponent implements OnInit {
  @ViewChild("errorModal") errorModal: ModalComponent;

  tenderPurchasePrice: Number;
  paymentMethod: PaymentMethod = {};
  creditCardName: string;
  loading: boolean = false;
  tenderId: number;
  tenderTitle: string;
  tenderDescription: string;
  tenderCustomer: string;
  tenderType: string;
  errorLoadingTender: string;
  error: string = "no_error";
  participation: Participation;
  prepaidCreditNumber: Number = 0;
  profile: Profile;
  usePrepaidCreditsDisabled: string = "";
  invitationToken = null;

  privacyForm = new FormGroup({
    conditions: new FormControl("", [Validators.required]),
    privacy: new FormControl("", [Validators.required]),
  });

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private stripeService: StripeService
  ) {}

  ngOnInit(): void {
    window["moment"] = moment;
    this.tenderTitle = localStorage.getItem("TENDER_TITLE");
    this.tenderDescription = localStorage.getItem("TENDER_DESCRIPTION");
    this.tenderCustomer = localStorage.getItem("TENDER_CUSTOMER");
    this.tenderType = localStorage.getItem("TENDER_TYPE");
    this.tenderId = +localStorage.getItem("TENDER_ID");

    if (this.route.snapshot.queryParams["invitationToken"] != undefined) {
      this.route.queryParams.subscribe((params) => {
        this.tenderId = params["tenderId"];
      });
      this.invitationToken = this.route.snapshot.queryParams["invitationToken"];
      console.log("Invitation Token " + this.invitationToken);
      this.commonService
        .getTenderService()
        .tenderTenderIdGet(this.tenderId)
        .subscribe((tender) => {
          this.tenderTitle = tender.title;
          this.tenderDescription = tender.description;
          this.tenderCustomer = tender.customer;
          this.tenderType = tender.tenderType;
        });
    }

    this.commonService.getProfile().then((profile: Profile) => {
      this.profile = profile;
      if (
        this.profile.participationPrepaidCredits &&
        this.profile.participationPrepaidCredits.remaining &&
        this.profile.participationPrepaidCredits.remaining > 0 &&
        moment(this.profile.participationPrepaidCredits.expirationDate) >=
          moment()
      ) {
        this.usePrepaidCreditsDisabled = "";
        this.prepaidCreditNumber =
          profile.participationPrepaidCredits.remaining;
      } else {
        this.usePrepaidCreditsDisabled = "-disabled";
      }
    });

    this.getTenderPurchasePrice();
    this.getPaymentMethod();
    console.log("tender id " + this.tenderId);
  }

  ngAfterViewInit(): void {
    if (this.errorLoadingTender) {
      this.errorModal.open();
    }
  }

  getTenderPurchasePrice() {
    this.commonService
      .getConfigurationVariables()
      .then((variables: ConfigurationVariablesList) => {
        if (this.tenderType === "COMPANY") {
          console.log(
            "TENDER_PARTICIPATION_PURCHASE_PRICE: " +
              variables["TENDER_PARTICIPATION_PURCHASE_PRICE"]
          );
          this.tenderPurchasePrice =
            variables["TENDER_PARTICIPATION_PURCHASE_PRICE"];
        } else if (this.tenderType === "PRIVATE") {
          console.log(
            "PRIVATE_TENDER_PARTICIPATION_PURCHASE_PRICE: " +
              variables["PRIVATE_TENDER_PARTICIPATION_PURCHASE_PRICE"]
          );
          this.tenderPurchasePrice =
            variables["PRIVATE_TENDER_PARTICIPATION_PURCHASE_PRICE"];
        }
      });
  }

  getPaymentMethod() {
    this.loading = true;
    this.commonService
      .getPaymentMethodService()
      .profilePaymentMethodGet()
      .subscribe(
        (paymentMethod: PaymentMethod) => {
          this.loading = false;
          this.paymentMethod = paymentMethod;
          this.creditCardName = GetCreditCardName(
            paymentMethod.creditCardBrand
          );
        },
        (error) => {
          this.loading = false;
          this.error =
            "Si è verificato un errore durante il caricamento della carta di credito.";
          console.log(error);
        }
      );
  }

  tenderParticipationPost(
    paymentMethod: Participation.PaymentMethodEnum,
    paymentMethodId: string,
    paymentIntentId: string,
    paymentIntentTransactionTime: number
  ) {
    this.participation.invitationToken = this.invitationToken;
    console.log(
      "Invitation token pre participation " + this.participation.invitationToken
    );
    this.participation.paymentMethod = paymentMethod;
    this.participation.stripePaymentMethodId = paymentMethodId;
    this.participation.paymentIntentId = paymentIntentId;
    this.participation.transactionTime = paymentIntentTransactionTime;

    console.log("participation obj");
    console.log(this.participation);
    this.commonService
      .getParticipationService()
      .tenderParticipationPost(this.participation)
      .subscribe(
        (res) => {
          console.log(res);
          this.loading = false;
          this.goToThanksPage(null);
        },
        (error) => {
          this.loading = false;
          this.goToThanksPage(error.error.errors[0]?.text);
        }
      );
  }

  buyTender() {
    this.resetError();
    if (
      !this.privacyForm.valid ||
      this.privacyForm.get("privacy").value === false ||
      this.privacyForm.get("conditions").value === false
    ) {
      this.error =
        "Per poter procedere è necessario prendere visione delle condizioni generali e della privacy.";
      console.log("Invalid privacy form");
      return;
    }

    this.loading = true;

    localStorage.removeItem("TENDER_TITLE");
    localStorage.removeItem("TENDER_DESCRIPTION");
    localStorage.removeItem("TENDER_CUSTOMER");
    this.participation = {} as Participation;
    this.participation.tenderId = this.tenderId;

    console.log("participation tender id " + this.participation.tenderId);

    this.participation.invitationToken = this.invitationToken;

    console.log("Token invito " + this.participation.invitationToken);

    const transactionInfo = { amount: this.tenderPurchasePrice } as PaymentInfo;

    this.commonService
      .getPaymentMethodService()
      .profileStripePaymentIntentPost(transactionInfo)
      .subscribe(
        (paymentIntent: ProfilePaymentIntent) => {
          //Payment succesfully directly on server. Save the participation
          this.tenderParticipationPost(
            Participation.PaymentMethodEnum.CreditCard,
            this.paymentMethod.creditCardToken,
            paymentIntent.paymentIntentId,
            paymentIntent.transactionTime
          );
        },
        (error) => {
          if (error.error.cardExceptionErrorCode === 'authentication_required') {
            this.confirmCardPayment(error.error.clientSecret, error.error.paymentMethodId);
        } else {
            this.loading = false;
            this.goToThanksPage(this.getCardErrorMessage(error.error.cardExceptionError) 
            + ". " + this.getCardErrorMessageDetail());
        }
        }
      );
  }

  confirmCardPayment(clientSecret: string, paymentMethodId: string) {
    this.stripeService
      .confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId,
      })
      .subscribe(
        (value: { paymentIntent: PaymentIntent; error: any }) => {
          if (value.paymentIntent) {
            //Client authorization sucess. Save the tender
            this.tenderParticipationPost(
              Participation.PaymentMethodEnum.CreditCard,
              this.paymentMethod.creditCardToken,
              value.paymentIntent.id,
              value.paymentIntent.created
            );
          } else {
            //Payment intent is null when customer close authentication window without proceede to authenticate
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
                this.goToThanksPage(this.getCardErrorMessage(error.error.cardExceptionError) 
                + ". " + this.getCardErrorMessageDetail());
        }
      );
  }

  getCardErrorMessage(cardExceptionError: string) {
    return "Si è verificato un errore nel pagamento con la carta xxxx-xxxx-xxxx-" +
        this.paymentMethod.creditCardLast4 + ": " + cardExceptionError;
  }

  getCardErrorMessageDetail() {
      return "Si prega di riprovare più tardi. Grazie"; 
  }

  goToThanksPage(error: string) {
    if (error) {
      localStorage.setItem("BUY_TENDER_PARTICIPATION_ERROR", error);
    } else {
      localStorage.removeItem("BUY_TENDER_PARTICIPATION_ERROR");
    }
    this.router.navigate(["/grazieacquistopartecipazione"]);
  }

  resetError() {
    this.error = "no_error";
  }

  buyPrepaidPacket() {
    this.router.navigate(["/acquistapacchetto"], {
      queryParams: { fromParticipationBuy: "yes" },
    });
  }

  usePrepaidCredits() {
    /*
        You cannot use prepaid credits if:
        - profile.prepaidCredits = null
        - profile.prepaidCredits.remaining = null || profile.prepaidCredits.remaining = 0
        - profile.prepaidCredits.expirationDate < current_date
        */

    if (
      this.profile.participationPrepaidCredits &&
      this.profile.participationPrepaidCredits.remaining &&
      this.profile.participationPrepaidCredits.remaining > 0 &&
      moment(this.profile.participationPrepaidCredits.expirationDate) >=
        moment()
    ) {
      this.participation = {} as Participation;
      this.participation.tenderId = this.tenderId;
      this.participation.invitationToken = this.invitationToken;
      console.log(
        "invitation token payment" + this.participation.invitationToken
      );
      this.tenderParticipationPost(
        Participation.PaymentMethodEnum.Prepaid,
        null,
        null,
        null
      );
    }
  }
}
